const o=36,t=2,c=320,e=280,n=336;export{t as DAY_MARGIN,o as DAY_SIZE,c as DIALOG_WIDTH,e as MAX_CALENDAR_HEIGHT,n as VIEW_HEIGHT};
//# sourceMappingURL=dimensions.js.map
